// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WI-z","twoColumnImage":"XI-z"};